import { useState } from "react";
import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import AuthSplit from "../components/sc/AuthSplit";
import { useAuth } from "../contexts/AuthContext";

export default function Login() {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, login } = useAuth();
  // Where to land after auth: the page the user was bounced from, else the dashboard.
  const from = location.state?.from?.pathname || "/overview";
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e?.preventDefault?.();
    setError("");
    setBusy(true);
    const res = await login(email.trim(), password);
    setBusy(false);
    if (res.ok) {
      toast.success("Welcome back");
      navigate(from, { replace: true });
    } else {
      setError(res.error || "Something went wrong");
    }
  };

  // Session already active (cookie restored on load) → skip the form entirely and
  // go straight to the dashboard.
  if (user) return <Navigate to={from} replace />;
  // While /auth/me is still resolving (user === null), hold a light loader instead
  // of flashing the login form to someone who turns out to be signed in already.
  if (user === null) {
    return (
      <div data-testid="login-loading" style={{ minHeight: "100vh", display: "grid", placeItems: "center", background: "#fff", fontFamily: "Inter, sans-serif", fontSize: 14, color: "#6b6b76" }}>
        Loading…
      </div>
    );
  }

  return (
    <AuthSplit
      headline={<>Hello<br />SuperCash! <span className="gl-wave">👋</span></>}
      blurb="Collect UPI payments straight into your own account. Payment links, QR, Auto Pay and payouts — all from one dashboard."
      title="Welcome Back!"
      subtitle="Log in to your merchant dashboard."
      onSubmit={submit}
      top={<Link to="/" data-testid="login-back-home" className="gl-back">← Back to home</Link>}
      footer={<p className="gl-help">Forgot password? <Link to="/forgot-password">Click here</Link></p>}
    >
      <input data-testid="auth-email" className="gl-input" type="text" placeholder="Email or phone" aria-label="Email or phone"
        value={email} onChange={(e) => setEmail(e.target.value)} autoComplete="email" autoFocus />
      <input data-testid="auth-password" className="gl-input" type="password" placeholder="Password" aria-label="Password"
        value={password} onChange={(e) => setPassword(e.target.value)} autoComplete="current-password" />
      {error && <div data-testid="auth-error" className="gl-err" role="alert">{error}</div>}
      <button data-testid="auth-submit" type="submit" disabled={busy} className="gl-btn">{busy ? "Signing in…" : "Login Now"}</button>
    </AuthSplit>
  );
}
